import { Directive } from '@angular/core';

@Directive({
    selector: '[st-item]',
})
export class ItemDirective {}
